import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import Alert from '../../modal/alert/Alert';
import SearchBar from '../datatable/SearchBar';
import DataTable from '../datatable/DataTable';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import FloorCreateModal from '../../modal/floor/FloorCreateModal';
import FloorEditModal from '../../modal/floor/FloorEditModal';
import FloorDuplicateModal from '../../modal/duplicate/FloorDuplicateModal';

import { getErrorValue, stringifyErrorMessage, withDefaultSort } from '../../utils/utility';

import {
  listFloor,
  searchFloorByText,
  addFloorToProject,
  clearErrorFloor,
  deleteFloor,
} from '../../redux/floor/floor_actions';
import { getProject } from '../../redux/projects/projects_actions';

export class FloorDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        id: 'name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id }),
        Cell: row => <Link to={`/floors/${row.value.id}`}>{row.value.name}</Link>,
        ...textColumn,
        entity: {
          list: (text, page) => searchFloorByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        width: 180,
        ...coeColumn,
      },
    ];

    this.state = {
      isShowCreateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listFloor(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );
    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  render() {
    const {
      categoryOption,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
      selectedItem: floor,
    } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isLoading,
      errorMessage,
      isDuplicating,
      isDeleting,
      t,
    } = this.props;

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar
          onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)}
          auxiliaryButton={<Button bsStyle="success" onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}>{t('create')}</Button>}
        />
        <FloorCreateModal
          building={{ id: buildingId }}
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <FloorEditModal
          section={floor}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
          floor={floor}
        />
        <FloorDuplicateModal
          item={floor}
          show={isShowDuplicateModal}
          title={t('copy floor')}
          label={t('new floor name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete component')}
          body={`${t('do you want to delete')} ${floor ? floor.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteFloor(floor)}
        />
        <DataTable
          columns={this.columns}
          data={this.props.floors}
          errorMessage={stringifyErrorMessage(errorMessage)}
          onActionEdit={item => this.setState({ isShowEditModal: true, selectedItem: item.original, isEdited: false })}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedItem: item.original, isDuplicated: false})}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  floors: state.floor.orderedIds.map(id => state.floor.objects[id]).filter(item => item.building_id === props.buildingId),
  filteredCount: state.floor.filteredCount,
  isFloorAdding: state.floor.isAddingToProject,
  isFloorRemoving: state.floor.isRemovingFromProject,
  isLoading: state.floor.isLoading,
  isCreating: state.floor.isCreating,
  isEditing: state.floor.isEditing,
  isDeleting: state.floor.isDeleting,
  isDuplicating: state.floor.isDuplicating,
  errorMessage: state.floor.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listFloor: (pageSize, page, sorted, filtered, isPublic) =>
    dispatch(listFloor(pageSize, page, sorted, filtered, isPublic, props.buildingId)),
  addFloorToProject: (id, buildingId) => dispatch(addFloorToProject(id, buildingId))
    .then(() => dispatch(getProject(props.buildingId))),
  deleteFloor: ({ id }) => dispatch(deleteFloor(id)),
  clearError: () => dispatch(clearErrorFloor()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(FloorDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/FloorDataTable.js